import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-file-input',
    templateUrl: './file-input.component.html',
    styleUrls: ['./file-input.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileInputComponent implements OnInit {
	@ViewChild('myInput', { static: true }) myInputVariable: ElementRef;

	@Input() appModel: any;
	@Input() required: boolean;
	@Input() topicon: boolean;
	@Input() accepted: string;
	@Input() multiple: boolean = false;
	@Output() appModelChange = new EventEmitter<string>();

	placeholder: string = 'Drag and drop here or click to browse a file'
	file_name: string;
	allowed_extensions: any = [];
	accepted_input_extensions: string;
	invalidFiles: any = [];
	list: any[] = [];

	onChangeHandler(event) {
		if (!this.multiple) {
			this.appModel = event.target.files[0]
			this.file_name = event.target.files[0].name;
		} else {
			this.appModel = event.target.files;
			this.file_name = `${event.target.files.length} ${event.target.files.length > 1 ? 'files' : 'file'} added.`;
		}
		this.appModelChange.emit(this.appModel);
	}

	onDropHandler(fileList: Array<File>) {
		if (!this.multiple) this.list = [];
		for (let file of fileList) {
			let ext = file.name.split('.')[file.name.split('.').length - 1];
			let isValid = this.allowed_extensions.length ? this.allowed_extensions.lastIndexOf(ext) != -1 : true;
			if (isValid) {
				if (!this.multiple) {  // only allows one file.
					this.appModel = file;
					this.file_name = file.name;
					this.appModelChange.emit(this.appModel);
					return;
				}
				else {
					this.list.push(file);
				}
			}
		}
		if (this.multiple) {
			this.appModel = this.list;
			this.file_name = `${this.list.length} ${this.list.length > 1 ? 'files' : 'file'} added.`;
			this.appModelChange.emit(this.appModel);
		}
	}

	onInvalidDropHandler(fileList: Array<File>) {
		this.invalidFiles = fileList;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.appModel && !changes.firstChange && changes.appModel.currentValue == undefined) {
			this.myInputVariable.nativeElement.value = "";
		}
		if (changes.accepted) {
			let capsAllowedExtension = [];
			// Formats elements and adds upper case options
			this.allowed_extensions = this.accepted.split(',').map(
				a => {
					let lower = a.replace(/\./g, '').toLowerCase();
					capsAllowedExtension.push(lower.toUpperCase());
					return lower;
				}
			);
			// Adds uppercase
			this.allowed_extensions.push(...capsAllowedExtension);
			// Removes repeated elements
			this.allowed_extensions = this.allowed_extensions.filter((a, index) => {
				return this.allowed_extensions.indexOf(a) == index;
			});

			this.accepted_input_extensions = this.allowed_extensions.map(a => `.${a}`).join(',');
		}
	}

	constructor() { }

	ngOnInit() {
		if (this.appModel) {
			this.file_name = this.appModel.name;
		}
		this.placeholder = this.multiple ? 'Drag and drop here or click to browse files' : 'Drag and drop here or click to browse a file';
	}
}
